import React from 'react';

const Icon = ({ size = '44', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 44 44" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black">
                <path
                    d="M29.94 15.216c.234.019 1.82-.023 2.042 0 4.083 0 6.124 3.382 6.124 6.125 0 1.36-.68 4.082-2.811 5.68-.234.15-1.698.299-1.952.444"
                    strokeWidth="2.041"
                />

                <path d="M13.298 15.217H7.854c.377.827 2.089 4.533 3.034 4.763" strokeWidth="2.041" strokeLinejoin="round" />

                <path
                    clipRule="evenodd"
                    d="M21.775 4.328a1.357 1.357 0 0 1 1.361 1.361c0 .376-.152.716-.398.962a1.357 1.357 0 0 1-.963.399c-.376 0-.716-.152-.962-.399a1.357 1.357 0 0 1-.399-.962c0-.376.152-.716.399-.962.246-.247.586-.399.962-.399Z"
                    strokeWidth="1.633"
                />

                <path
                    d="M33.82 35.538c.017-.168.032-.337.047-.506.103-1.198.157-2.427.157-3.679 0-5.95-1.21-11.37-3.193-15.447-2.24-4.604-5.468-7.494-9.056-7.494-3.603 0-6.842 2.913-9.083 7.55-1.967 4.07-3.165 9.469-3.165 15.391a42.912 42.912 0 0 0 .212 4.278m3.871-20.414h17.692"
                    strokeWidth="2.041"
                />

                <path d="M20.414 31.549h2.722" strokeWidth="2.041" strokeLinecap="round" />

                <rect x="7.825" y="35.29" width="27.899" height="3.402" rx="1.701" strokeWidth="2.041" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M0 .246h43.55v43.55H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
